import { Component } from '@angular/core';
import { DynamicDialogComponent } from './dynamic-dialog.component';
import { DynamicDialog } from './dynamic-dialog';

@Component({
  imports: [DynamicDialogComponent],
  template: `
    <ct-dynamic-dialog [title]="'Vorgang abschließen'">
      <p>Bist du sicher, dass du die Bearbeitung abschließen möchtest?</p>
    </ct-dynamic-dialog>
  `,
})
export class ExtractionCompletionDialogComponent implements DynamicDialog<boolean> {}
